import React from 'react';
import TodoInput from './components/InputTodo';

class App extends React.Component {
  state = {  } 
  render() { 
    return (
      <>
        <TodoInput/>
      </>
    );
  }
}
export default App;